import axios from 'axios';
import { BASE_PROJECT_PATH, generateRoutePath } from '../routes';
import { PREFIX_URL } from './config';

const URLS = {}

URLS.BASE_URL = `${PREFIX_URL}/workstream`;
URLS.NEW_BASE_URL = `${PREFIX_URL}/v01/workstreams`;
URLS.CHECK_NAME = `${URLS.BASE_URL}/checkName`;
URLS.CHECK_EMAIL = `${URLS.NEW_BASE_URL}/checkEmail`;
URLS.CHECK_EXISTING_EMAIL = `${URLS.NEW_BASE_URL}/:workstreamId/change-email-allowed`;

export const fetchList = async(params) => {
    return await axios.get(URLS.BASE_URL, {params})
    .catch(error => {
        console.error(error);
    });
}

export const checkName = async(params) => {
    return await axios.get(URLS.CHECK_NAME, {params})
        .then(() => {
            return true;
        })
        .catch(() => {
            return false;
        })
}

export const checkEmail = async(params) => {
    return await axios.get(URLS.CHECK_EMAIL, {params})
        .then(() => {
            return true;
        })
        .catch(() => {
            return false;
        })
}

export const checkExistingEmail = async(params) => {
    return await axios.get(generateRoutePath(URLS.CHECK_EXISTING_EMAIL, {workstreamId: params.workstreamId}), {
        params: {
            email: params.email
        }
    })
        .then(() => {
            return true;
        })
        .catch(() => {
            return false;
        })
}